export class VendorsDataDto {
    id: number;
    jobworkId: number;
    vendorName: string;
    shahiPrice: number;
    vendorPrice: number;
    finalPrice: number;
    vendorAccepted: boolean;

    constructor(
        id: number,
        jobworkId: number,
        vendorName: string,
        shahiPrice: number,
        vendorPrice: number,
        finalPrice: number,
        vendorAccepted: boolean
    ) {
        this.id = id;
        this.jobworkId = jobworkId;
        this.vendorName = vendorName;
        this.shahiPrice = shahiPrice;
        this.vendorPrice = vendorPrice;
        this.finalPrice = finalPrice;
        this.vendorAccepted = vendorAccepted;
    }
}
